module.exports = __webpack_public_path__ + "img/avatar-2.56689437.png";